import {SliderBase} from "@share/presentation/sliders/SliderBase";
import {isLeftBorderExceeded, isRightBorderExceeded} from "@share/presentation/helpers/BorderHelper";
import {GoToParams} from "@share/presentation/types/GoToParams";
import {lastOffset} from "@share/presentation/helpers/OffsetHelper";

export class FluentSlider extends SliderBase {
    constructor(isClickable = true, needToEmitMoved = false) {
        super(isClickable, needToEmitMoved, true);
    }

    dragEnd(currentOffset: number): GoToParams {
        let result: GoToParams = {};

        if (this.state.isLeftBorderExceeded()) {
            result.offset = 0;
        }

        if (this.state.isRightBorderExceeded(this.params.totalSize, this.params.slideSize)) {
            result.offset = lastOffset(this.params.slidesLength, this.params.slideSize);
        }

        return result;
    }

    shiftSlide(direction: 1 | -1, currentOffset: number): GoToParams {
        const delta = currentOffset % this.params.slideSize;
        let lowBorder = currentOffset - delta;
        if (direction == 1) {
            lowBorder -= this.params.slideSize;
        }
        else if (delta == 0) {
            lowBorder += this.params.slideSize;
        }

        if (isLeftBorderExceeded(lowBorder)) {
            lowBorder = 0;
        }
        else if (isRightBorderExceeded(lowBorder, this.params.totalSize, this.params.slideSize, this.state.threshold)) {
            lowBorder = -(this.params.slidesLength - 1) * this.params.slideSize;
        }

        return {
            offset: lowBorder
        };
    }

    isFirst(): boolean {
        return false;
    }

    isLast(): boolean {
        return false;
    }
}
